import * as types from "./types";
import Cookies from "js-cookie";

const mutations = {
  [types.SET_LOADING](state, payload) {
    // save in store
    state.isLoading = payload;
  },
  [types.SET_LOADING_ICON](state, payload) {
    // save in store
    state.loadingIcon = payload;
  },
  [types.SET_PRINTOUT_LINK](state, payload) {
    // save in store
    state.printoutLink = payload;
  },
  [types.IS_DEBUG](state, payload) {
    state.isDebug = payload;
  },
  [types.IS_IN_MANAGEMENT](state,payload){
    state.isInManagement = payload;
  }
};

export default mutations;
